module.exports = __webpack_public_path__ + "img/apartment_dialog_icon01.0e02ffe6.png";